import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Paging } from '@pineapplelab/paging';
import { isNullOrUndefined } from '@pineapplelab/util';
import { Base } from 'src/app/models/base';

@Component({
  selector: 'app-paging-search',
  templateUrl: './paging-search.component.html',
  styleUrls: ['./paging-search.component.scss']
})
export class PagingSearchComponent {
  @Input() paging: Paging;
	@Output() pagingChanged = new EventEmitter<Paging>();
	@Input() wrap: boolean = false;
	@Input() invisibleBackground: boolean = false;
  @Input() showOrderArrow: boolean = false;

	OrderType = Paging.orderType;
	filterByLabel: string = 'Filter by:'
	anyLabel: string = 'None'
	searchPlaceholder: string;
	constructor() { }

	ngOnInit() {
		this.setOrderByOption(this.paging.orderBy);
		if (this.paging.pagingSearchOptions.noOrderOptions) {
			this.searchPlaceholder = this.paging.pagingSearchOptions.placeholder;
		}
	}

	emitPagingChanged() {
    if (!isNullOrUndefined( this.paging.loadData ) && typeof this.paging.loadData === 'function') {
      this.paging.loadData();
    }
		this.pagingChanged.emit(this.paging);
	}

	changeOrderType(orderType: Paging.orderType) {
		this.paging.orderType = orderType;
		this.emitPagingChanged();
	}

	changeSearch(search: string) {
		const temporalSearch = search;

		setTimeout(() => {

			if (temporalSearch === this.paging.search) {
				if (this.paging.orderDataType === null || this.paging.orderDataType === Paging.dataType.string) {
					this.paging.orderType = Paging.orderType.asc;
				}
				this.emitPagingChanged();
			}
		}, 400);
	}

	changeOrderBy(value: string) {
		this.paging.orderBy = value !== undefined ? value : null;
		this.setOrderByOption(value);
		this.emitPagingChanged();
	}

	setOrderByOption(value: string) {
		const option = this.paging.orderOptions.find(o => o.field === value);
		if (option !== undefined) {
			this.paging.orderDataType = option.dataType;
			this.searchPlaceholder = option.placeholder;
		}
	}
}
